module.exports = __webpack_public_path__ + "static/media/undraw_checklist_7q37.c9526049.svg";